import styled from 'styled-components';

export const StyledFAQ = styled.div<{ merchantColor: string }>`
  min-height: 430px;
  display: flex;
  flex-direction: column;
  margin: 42px 0 0 0;
  flex-grow: 1;

  .faq-tab__header, .faq-tab__footer {
    flex-grow: 0;
  }

  .faq-tab__header {
    margin: 0 0 10px 0;
  }

  .faq-tab__header__back-button {
    font-family: inherit;
    color: ${({ merchantColor }) => merchantColor};
    line-height: inherit;
    max-height: inherit;
    cursor: pointer;

    path {
      fill: ${({ merchantColor }) => merchantColor};
    }
  }

  .faq-tab__header__back-button:focus {
    outline: 0;
  }

  .faq-tab__header__back-button:focus .faq-tab__header__back-button__arrow,
  .faq-tab__header__back-button:hover .faq-tab__header__back-button__arrow {
    margin-right: 11px;
    margin-left: -4px;
  }

  .faq-tab__header__back-button__arrow {
    margin-right: 7px;
    transform: rotateX(0deg) rotateY(0deg) rotateZ(180deg);
    transition: all 400ms ease 0s;
  }

  .faq-tab__header__back-button__text {
    display: inline-block;
  }

  .faq-tab__header__title {
    font-size: 21px;
    line-height: 22px;
    margin: 20px 0 0 0;
  }

  .faq-tab__content {
    min-height: 400px;
    height: 0; // will get resized because of flexbox - necessary to make overflow work
    overflow-y: auto;
    flex-grow: 1;
    margin: 0;
  }

  .faq-tab__footer {
    width: 100%;
    padding-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-grow: 0;
  }

  #learn-more-link {
    font-size: 14px;
  }

  .faq-tab__footer__text {
    white-space: nowrap;
    max-width: 300px;
    text-overflow: ellipsis;
  }

  @media (min-width: 479px) {
    .faq-tab__header {
      margin: 0 0 20px 0;
    }

    .faq-tab__header__title {
      font-size: 28px;
      line-height: normal;
    }
  }
`;
